<template>
	<div id="app">
		<slot></slot>
	</div>
</template>

<style lang="less">
	html, body {
		margin: 0;
		padding: 0;
	}
</style>

<script>
	export default {};
</script>



// WEBPACK FOOTER //
// LumiApp.vue?32d0b783